import axiosInstance from "./client";

const getManufacturerList = async () => {
  const response = await axiosInstance.get(`/api/manufacturer/all`);

  return response.data;
};

const getDeletedManufacturerList = async () => {
  const response = await axiosInstance.get(`/api/manufacturer/deleted`);

  return response.data;
};

const getManufacturerDetail = async (manufacturerId) => {
  const response = await axiosInstance.get(
    `/api/manufacturer/details?manufacturer_id=${manufacturerId}`
  );

  return response.data;
};

const editManufacturer = async (data) => {
  const response = await axiosInstance.put(`/api/manufacturer/update`, data);

  return response.data;
};

const addManufacturer = async (data) => {
  const response = await axiosInstance.post(`/api/manufacturer/create`, data);

  return response.data;
};

const deleteManufacturer = async (manufacturerId) => {
  const response = await axiosInstance.delete(
    `/api/manufacturer/delete?manufacturer_id=${manufacturerId}`
  );

  return response.data;
};

const hardDeleteManufacturer = async (manufacturerId) => {
  const response = await axiosInstance.delete(
    `/api/manufacturer/delete-hard?manufacturer_id=${manufacturerId}`
  );

  return response.data;
};

const restoreManufacturer = async (manufacturerId) => {
  const response = await axiosInstance.post(
    `/api/manufacturer/restore?manufacturer_id=${manufacturerId}`
  );

  return response.data;
};

export {
  getManufacturerList,
  getManufacturerDetail,
  editManufacturer,
  addManufacturer,
  deleteManufacturer,
  getDeletedManufacturerList,
  hardDeleteManufacturer,
  restoreManufacturer,
};
